const Sentiment = Object.freeze({
  NEGATIVE: 'Negative',
  NEUTRAL: 'Neutral',
  POSITIVE: 'Positive',
  MIXED: 'Mixed',
  NONE: 'None'
})
export default Sentiment
export type SentimentStrings = typeof Sentiment[keyof typeof Sentiment]
// RESERVE BELOW
